/**
 * API client para o app `unidades/` do backend.
 *
 * Cada usuario so enxerga as unidades da propria marcenaria. O frontend usa
 * o primeiro resultado como default em criacao de orcamento.
 */

const PREFIXO = "/api/unidades";

export function listarUnidades(request) {
  return request(PREFIXO);
}

export async function unidadeDefault(request) {
  try {
    const payload = await listarUnidades(request);
    const items = Array.isArray(payload) ? payload : payload?.results || [];
    return items[0] || null;
  } catch {
    return null;
  }
}
